module.exports = __webpack_public_path__ + "img/donante-ciudadana.b0058bef.png";